import axios from '@/libs/axiosInstance';
import { create } from 'zustand';

interface ShopifyState {
  isLoading: boolean;
  setLoading: (loading: boolean) => void;
  connect: (shop: string) => Promise<void>;
}

export const useShopifyStore = create<ShopifyState>((set) => ({
  isConnected: false,
  isLoading: false,

  setLoading: (loading) => set({ isLoading: loading }),

  // Shopify can only be disconnected through Shopify admin
  // No disconnect function needed here

  connect: async (shop) => {
    set({ isLoading: true });
    await axios.post('/dashboard/integrations/shopify/start', { shop });
    const redirectUrl = `${import.meta.env.VITE_API_URL}/integrations/shopify/redirect-url?shop=${shop}`;

    window.location.href = redirectUrl;
  },
}));
